module.exports = ['$scope', '$routeParams', '$location', 'railsResource', 'users',
  function($scope, $routeParams, $location, $resource, users) {
    const PortfolioModel = $resource('/portfolio_models/:id', { id: '@id' },
      {
        sendLabels: { method: 'POST', url: '/portfolio_models/send_labels' },
        syncLabels: { method: 'PUT', url: '/portfolio_models/sync_labels' },
        getTranslationsUrl: { method: 'GET', url: '/portfolio_models/get_translations_url' },
        getAttributesAndRisksDisplayNames: { method: 'GET', url: '/portfolio_models/attributes_and_risks_display_names' },
      },
    );

    this.pmList = [];
    this.isLoadingAttributesAndRisksDisplayNames = true;
    this.investmentPreferenceAttributesDisplayNames = {};
    this.portfolioRisksDisplayNames = {};

    this.isSendLabelsPending = false;
    this.isSyncLabelsPending = false;

    PortfolioModel.getTranslationsUrl(result => {
      this.translationsUrl = result.url;
    });

    this.hasSelectedModelName = () => !!this.selectedModel.nameEn || !!this.selectedModel.nameFr;

    this.getAttributesAndRisksDisplayNames = () => {
      PortfolioModel.getAttributesAndRisksDisplayNames((result) => {
        this.investmentPreferenceAttributesDisplayNames = result.investmentPreferenceAttributes;
        this.portfolioRisksDisplayNames = result.portfolioRisks;

        this.isLoadingAttributesAndRisksDisplayNames = false;
      })
    }

    this.getAttributesAndRisksDisplayNames();

    this.getPortfolioModels = () => {
      this.portfolioModels = PortfolioModel.query({ include_attributes_and_risks: true }, (result) => {
        result.map((pm) => {
          if (pm.category === 'null') { pm.category = 'other'; }
          this.pmList.push(pm.category);
          this.pmList = _.uniq(this.pmList);
        });
        const portfolioModelList = _.sortBy(result, 'risk');
        if (portfolioModelList instanceof Array) {
          this.selectPortfolioModel(portfolioModelList[0])
        }
        return portfolioModelList;
      });
    };

    this.getPortfolioModels();

    this.displayInOnboarding = () => {
      if ((this.selectedModel.displayInOnboarding = true)) {
        return this.selectedModel.displayInOnboarding = false;
      } else {
        return this.selectedModel.displayInOnboarding = true;
      }
    };

    this.filteredPortfolios = () => {
      if (this.selectedModel) {
        return this.selectedModel.portfolios;
      }
    };

    this.selectedPortfolioModelChanged = () => {
      if (!this.selectedModel || !this.selectedModelOriginal) return false;

      if (this.selectedModel.nameEn === this.selectedModelOriginal.nameEn
        && this.selectedModel.shortDescriptionEn === this.selectedModelOriginal.shortDescriptionEn
        && this.selectedModel.descriptionEn === this.selectedModelOriginal.descriptionEn
        && this.selectedModel.explanationEn === this.selectedModelOriginal.explanationEn
        && this.selectedModel.riskScore === this.selectedModelOriginal.riskScore
        && this.selectedModel.risk === this.selectedModelOriginal.risk
        && this.selectedModel.category === this.selectedModelOriginal.category
        && this.selectedModel.displayInOnboarding === this.selectedModelOriginal.displayInOnboarding
        && this.selectedModel.etfOnly === this.selectedModelOriginal.etfOnly
        && this.selectedModel.conversationRequired === this.selectedModelOriginal.conversationRequired
        && this.selectedModel.minimumInitialInvestment === this.selectedModelOriginal.minimumInitialInvestment
        && _.isEqual(this.selectedModel.investmentPreferenceAttributes, this.selectedModelOriginal.investmentPreferenceAttributes)
        && _.isEqual(this.selectedModel.portfolioRisks, this.selectedModelOriginal.portfolioRisks)
      ) {
        return false;
      }

      return true;
    }

    this.selectPortfolioModel = pm => {
      if (pm && this.selectedPortfolioModelChanged() && !confirm("Are you sure? Unsaved changes will be lost.")) {
        return;
      }
      if (pm && this.selectedModelOriginal) _.assign(this.selectedModel, this.selectedModelOriginal);
      this.selectedModel = pm;
      this.selectedModelOriginal = _.cloneDeep(pm);
      if (this.newPortfolioModel && (pm !== this.newPortfolioModel)) {
        _.pull(this.portfolioModels, this.newPortfolioModel);
        this.newPortfolioModel = null;
      }
      return this.editSelectedModel = false;
    };

    this.selectedPortfolioModelInvestmentPreferenceAttributes = () => {
      if (this.selectedModel) {
        return Object.keys(this.selectedModel.investmentPreferenceAttributes);
      }
      return [];
    }

    this.selectedPortfolioModelPortfolioRisks = () => {
      if (this.selectedModel) {
        return Object.keys(this.selectedModel.portfolioRisks);
      }
      return [];
    }

    this.createPortfolioModel = () => {
      if (this.newPortfolioModel) return;

      const newInvestmentPreferenceAttributes = Object.keys(this.investmentPreferenceAttributesDisplayNames).reduce((obj, attribute) => {
        obj[attribute] = false;
        return obj
      }, {});

      const newPortfolioRisks = Object.keys(this.portfolioRisksDisplayNames).reduce((obj, attribute) => {
        obj[attribute] = false;
        return obj
      }, {});

      this.newPortfolioModel = new PortfolioModel({
        nameEn: 'New Portfolio Model',
        shortDescriptionEn: '',
        descriptionEn: '',
        explanationEn: '',
        riskScore: null,
        risk: 3,
        category: null,
        displayInOnboarding: true,
        etfOnly: false,
        conversationRequired: false,
        minimumInitialInvestment: null,
        investmentPreferenceAttributes: newInvestmentPreferenceAttributes,
        portfolioRisks: newPortfolioRisks
      });
      this.portfolioModels.push(this.newPortfolioModel);
      this.selectPortfolioModel(this.newPortfolioModel);
      return this.editSelectedModel = true;
    };

    this.savePortfolioModel = () => {
      const after = () => {
        this.newPortfolioModel = null;
        this.selectedModelOriginal = _.clone(this.selectedModel);
        return this.editSelectedModel = false;
      };
      if (this.selectedModel.id != null) {
        return this.selectedModel.$update({ include_attributes_and_risks: true }, after);
      } else {
        return this.selectedModel.$save({ include_attributes_and_risks: true }, after)
      }
    };

    this.archivePortfolioModel = (model) => {
      if (!confirm("Archiving this portfolio model will remove the portfolio model from all accounts. Are you sure you want to archive this portfolio model?")) { return; }
      const after = () => {
        _.pull(this.portfolioModels, model);
        return this.selectPortfolioModel();
      };
      return model.$delete(after);
    };

    this.allocationTotal = assetAllocation => {
      return _.sumBy(assetAllocation, 'allocation');
    };

    this.allocationTotalValid = assetAllocation => {
      return Math.abs(this.allocationTotal(assetAllocation) - 1) < 0.0001;
    };

    this.sendLabels = () => {
      this.isSendLabelsPending = true;
      PortfolioModel.sendLabels(() => {
        this.isSendLabelsPending = false;
      });
    };

    this.syncLabels = () => {
      this.isSyncLabelsPending = true;
      PortfolioModel.syncLabels(() => {
        this.getPortfolioModels();
        this.isSyncLabelsPending = false;
      });
    };

    this.displayRiskScore = () => {
      return this.selectedModel.riskScore === null ? 'Not Set' : this.selectedModel.riskScore
    };

    this.userHasPmOrComplianceRole = () => {
      return ['pm', 'compliance'].some((role) => users.getCurrentUser().roles.includes(role));
    }

    this.displayArchiveBtn = () => {
      return users.getCurrentUser().roles.includes('archive_portfolio_model') && this.selectedModel.referenceCount == 0;
    }

    return this;
  }
];
